<template>
  <div class="d-xl-flex">
    <div class="w-100">
      <div class="d-md-flex">
        <div class="card filemanager-sidebar me-md-2">
          <div class="card-body">
            <div class="d-flex flex-column h-100">
              <div class="mb-4" style="min-width: 200px;">
                <div class="card filemanager-sidebar">
                  <div class="text-center" v-if="storageInfo">
                    <h5 class="font-size-15 mb-4">{{ $t("file-manager.organization-storage-status") }}</h5>
                    <VueApexCharts :series="storageRate" class="apex-charts" type="radialBar" height="150" dir="ltr" :options="chartOptions"></VueApexCharts>

                    <p class="text-muted mt-4">{{ storageInfo.used | formatByte }} / {{ storageInfo.total | formatByte }} {{ $t("file-manager.used") }}</p>
                  </div>
                </div>

                <ul class="list-unstyled categories-list" v-if="parentCategoryPagination">
                  <li v-for="category in parentCategoryPagination.docs" :key="category.id" class="category-item">
                    <div :class="selectedParentCategory && category._id === selectedParentCategory._id ? 'bg-light' : ''">
                      <span
                        @click="selectParentCategory(category)"
                        class=" align-items-center"
                        data-toggle="collapse"
                        v-b-toggle.categories-collapse
                        role="button"
                        aria-expanded="false"
                        aria-controls="categories-collapse"
                      >
                        <i class="mdi mdi-folder font-size-16 text-warning mr-1"></i>
                        {{ category.name | translate }}
                      </span>

                      <span class="trash-icon" v-if="!category.categoryDefinition"> <i class="bx bx-trash text-danger hand" @click="removeCategory(category)"></i></span>
                    </div>
                  </li>
                </ul>

                <div v-if="parentCategoryPagination" class="row">
                  <div class="col">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="parentCategoryRequest.options.page"
                        :total-rows="parentCategoryPagination.totalDocs"
                        :per-page="parentCategoryPagination.limit"
                        limit="3"
                        size="sm"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- filemanager-leftsidebar -->

        <div class="w-100">
          <b-breadcrumb v-if="breadcrumb && breadcrumb.length" class="m-0">
            <b-breadcrumb-item v-for="(item, index) in breadcrumb" :key="index" @click="breadcrumbClick(item)">
              {{ item.name | translate }}
            </b-breadcrumb-item>
          </b-breadcrumb>

          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right mt-2 mb-2">
                  <button @click="createNewFolder()" class="btn btn-light">{{ $t("file-manager.new-folder") }}</button>
                </div>
              </div>
              <div class="w-100">
                <right-panel class="float-right" id="sidebar-new-file-category" width="600px" :icon="'mdi mdi-plus'" @hidden="fileCategoryRightPanelClosed">
                  <div class="pl-5 pr-5">
                    <file-category-form v-if="showCategoryForm" :scope="scope" :closeOnSave="true" :hide-library="true" />
                  </div>
                </right-panel>

                <right-panel class="float-right" id="sidebar-accessing-member" width="800px" :icon="'mdi mdi-plus'" @hidden="rightPanelClosed">
                  <div class="pl-5 pr-5">
                    <file-accessing-members-form v-if="showAccessingMembers" :hide-library="true" />
                  </div>
                </right-panel>

                <right-panel class="float-right" id="sidebar-file-upload" width="800px" :icon="'mdi mdi-plus'" @hidden="rightPanelClosed">
                  <div class="pl-5 pr-5">
                    <file-upload v-if="showUploadForm" :closeOnSave="true" :scope="scope" :hide-library="true" />
                  </div>
                </right-panel>

                <div v-if="!hasQuesyParams">
                  <div class="row" v-if="subCategoryPagination">
                    <div class="col-4" v-for="category in subCategoryPagination.docs" :key="category.id" @click="selectSubCategory(category)">
                      <div class="card shadow-none border">
                        <div class="card-body p-3">
                          <div class="">
                            <div class="float-end ms-2">
                              <b-dropdown toggle-class="font-size-16 text-muted p-0" menu-class="dropdown-menu-end" class="mb-2" variant="white" right>
                                <template #button-content>
                                  <i class="mdi mdi-dots-horizontal"></i>
                                </template>

                                <b-dropdown-item @click="removeSubCategory(category)">{{ $t("common.delete") }}</b-dropdown-item>
                              </b-dropdown>
                            </div>
                            <div class="avatar-xs me-3 mb-3">
                              <div class="avatar-title bg-transparent rounded">
                                <i class="bx bxs-folder font-size-24 text-warning"></i>
                              </div>
                            </div>
                            <div class="d-flex">
                              <div class="overflow-hidden me-auto" v-b-tooltip.hover :title="$options.filters.translate(category.name)">
                                <h5 class="font-size-14 text-truncate mb-1">
                                  <a href="javascript: void(0);" class="text-body"
                                    ><span> {{ category.name | translate | summary }}</span></a
                                  >
                                </h5>
                                <p class="text-muted text-truncate mb-0">
                                  <!-- 12 Files -->
                                </p>
                              </div>
                              <div class="align-self-end ms-2">
                                <p class="text-muted mb-0">
                                  <!-- 6GB -->
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="subCategoryPagination && subCategoryPagination.docs" class="row">
                    <div class="col" v-if="subCategoryPagination.docs.length > 0">
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination
                          v-model="subCategoryRequest.options.page"
                          :total-rows="subCategoryPagination.totalDocs"
                          :per-page="subCategoryPagination.limit"
                          limit="10"
                          size="sm"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="relatedEntityInfo">
                <h5 class="font-size-16 mb-0 ">
                  <span class="bg-info-light mt-1 "></span>
                  <span class="badge badge-main  text-wrap">
                    {{ $t("file-manager.entity-files", { name: relatedEntityInfo.type + " / " + relatedEntityInfo.name }) }}
                  </span>
                </h5>
              </div>
              <div class="mt-4">
                <div class="d-flex flex-wrap">
                  <h5 class="font-size-16 me-3">{{ $t("file-manager.files") }}</h5>
                </div>

                <div class="search-box mb-2 me-2">
                  <div class="search2">
                    <div class="search2--icon"><i class="iconoir-search"></i></div>
                    <input class="search2--input" type="text" :placeholder="$t('common.search')" v-model="nameFilter" />
                  </div>
                </div>
                <hr class="mt-2" />

                <div class="table-responsive" style="min-height: 440px;">
                  <table class="table align-middle  table-hover mb-0">
                    <thead>
                      <tr>
                        <th>{{ $t("file-manager.name") }}</th>
                        <th>{{ $t("file-manager.no") }}</th>
                        <th>{{ $t("common.version") }}</th>
                        <th>{{ $t("file-manager.upload-date") }}</th>
                        <th>{{ $t("file-manager.size") }}</th>
                        <th>{{ $t("file-manager.uploader") }}</th>
                        <th>{{ $t("file-manager.admin") }}</th>
                        <th>{{ $t("policy.text") }}</th>
                        <th>{{ $t("question.text") }}</th>
                        <th colspan="2">
                          <button @click="createNewFile()" class="btn btn-light float-right">{{ $t("file-manager.file-upload") }}</button>
                        </th>
                      </tr>
                    </thead>
                    <tbody v-if="filePagination">
                      <tr v-if="filePagination.docs" v-for="file in filePagination.docs" :key="file.id">
                        <td>
                          <a href="javascript: void(0);" class="text-dark fw-medium" v-b-tooltip.hover :title="$options.filters.translate(file.name)"
                            ><i class="mdi mdi-file-document font-size-16 align-middle text-primary me-2"></i> {{ file.name | translate | summary(20) }}</a
                          >
                        </td>
                        <td class="file-no-cell">{{ file.no }}</td>
                        <td>{{ file.version }}</td>
                        <td>{{ file.updatedAt | date(true) }}</td>
                        <td>{{ file.size | formatByte }}</td>
                        <td>
                          <span v-if="file.uploader">{{ file.uploader.name }}</span>
                        </td>
                        <td>
                          <span v-if="file.admin">{{ file.admin.name }}</span>
                        </td>
                        <td>
                          <ul v-if="file.entity && file.entity.policy && file.entity.policy.length" class="mb-0 pl-3">
                            <li v-for="p in file.entity.policy" :key="p._id || p.name">
                              {{ p.name ? $options.filters.translate(p.name) : p._id }}
                            </li>
                          </ul>
                          <span v-else>-</span>
                        </td>
                        <td>
                          <ul
                            v-if="file.entity && file.entity.question && file.entity.question.length && file.entity.questionSet && file.entity.questionSet.length"
                            class="mb-0 pl-3"
                          >
                            <li v-for="p in file.entity.question" :key="p._id || p.name">
                              {{ getQuestionDisplayOrder(file.entity.questionSet[0], p) }}
                            </li>
                          </ul>
                          <span v-else>-</span>
                        </td>

                        <td>
                          <b-dropdown class="float-right mr-4" toggle-class="font-size-16 text-muted p-0" menu-class="dropdown-menu-end" variant="white" right>
                            <template #button-content>
                              <i class="mdi mdi-dots-horizontal"></i>
                            </template>

                            <b-dropdown-item @click="editAccessingMember(file)">{{ $t("accessing-persons.text") }}</b-dropdown-item>
                            <!-- <b-dropdown-item @click="viewVersions(file)">{{ $t("file-manager.view-versions") }}</b-dropdown-item> -->
                            <b-dropdown-item @click="editFile(file)">{{ $t("common.edit") }}</b-dropdown-item>
                            <b-dropdown-item v-if="file.isPeriodical" @click="startApprovalProcess(file)">{{ $t("file-manager.start-approval") }}</b-dropdown-item>
                            <b-dropdown-item @click="downloadFile(file)">{{ $t("common.download") }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item @click="deleteFile(file)">{{ $t("common.delete") }}</b-dropdown-item>
                          </b-dropdown>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-if="filePagination && filePagination.docs" class="row">
                    <div class="col" v-if="filePagination.docs.length > 0">
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination
                          v-model="fileRequest.options.page"
                          :total-rows="filePagination.totalDocs"
                          :per-page="filePagination.limit"
                          limit="10"
                          size="sm"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end card -->
        </div>
        <!-- end w-100 -->
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import FileAccessingMembersForm from "./file-accessing-members-form.vue";
import FileCategoryForm from "./file-category-form.vue";
import FileHistory from "./file-history.vue";
import FileUpload from "./file-upload.vue";

export default {
  props: ["scope"],
  components: {
    FileCategoryForm,
    FileUpload,
    FileAccessingMembersForm,
    FileHistory,

    VueApexCharts,
  },
  data() {
    return {
      relatedEntityInfo: undefined,
      breadcrumb: [],
      nameFilter: undefined,
      showAccessingMembers: false,
      showCategoryForm: false,
      showUploadForm: false,
      showHistory: false,
      historyId: undefined,

      parentCategoryRequest: {
        options: { page: 1, limit: 10, sort: {} },
        query: { parent: { value: { $exists: false }, isObject: true } },
      },

      fileRequest: {
        options: { page: 1, limit: 10, sort: { createdAt: "desc" } },
        query: { latest: { value: true, isObject: true } },
      },

      subCategoryRequest: {
        options: { page: 1, limit: 10, sort: {} },
        query: {},
      },

      chartOptions: {
        chart: {
          height: 150,
          type: "radialBar",
          sparkline: {
            enabled: true,
          },
        },
        colors: ["#556ee6"],
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#e7e7e7",
              strokeWidth: "97%",
              margin: 5, // margin is in pixels
            },
            hollow: {
              size: "60%",
            },

            dataLabels: {
              name: {
                show: false,
              },
              value: {
                offsetY: -2,
                fontSize: "16px",
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        stroke: {
          dashArray: 3,
        },
      },
    };
  },
  watch: {
    nameFilter(n, o) {
      if (n) {
        this.fileRequest.query = { ...this.fileRequest.query, name: { value: n } };
      } else {
        this.fileRequest.query["name"] = null;
        delete this.fileRequest.query["name"];
      }
    },
    selectedParentCategory: {
      deep: true,
      handler() {
        this.fetchSubCategories();
      },
    },

    selectedSubCategory: {
      deep: true,
      handler() {
        this.fetchSubCategories();
      },
    },
    parentCategoryRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.fetchParentCategories());
      },
    },
    fileRequest: {
      deep: true,
      handler() {
        this.debounce(() => this.fetchFiles());
      },
    },
    subCategoryRequest: {
      deep: true,
      handler() {
        this.debounce(() => this.fetchSubCategories());
      },
    },
  },
  computed: {
    hasQuesyParams() {
      return Object.keys(this.$route.query).length > 0;
    },

    storageInfo() {
      return this.$store.getters[`fileManager/storageInfo`];
    },
    storageRate() {
      const rate = [Math.floor((this.storageInfo.used * 100) / this.storageInfo.total)];
      return rate > 100 ? [100] : rate;
    },
    filePagination() {
      return this.$store.getters[`fileManager/pagination`];
    },
    parentCategoryPagination() {
      return this.$store.getters["organizationFileCategory/parentCategoryPagination"];
    },
    subCategoryPagination() {
      return this.$store.getters["organizationFileCategory/subCategoryPagination"];
    },
    selectedParentCategory() {
      return this.$store.getters["organizationFileCategory/selectedParentCategory"];
    },
    selectedSubCategory() {
      return this.$store.getters["organizationFileCategory/selectedSubCategory"];
    },
  },

  async mounted() {
    this.$store.dispatch(`fileManager/storage`);
    if (this.hasQuesyParams) {
      await this.fetchFiles(); //query ile gelince işe yarıyor gibi duruyor ama incelemek lazım
      this.handleHistoryIdParams();
    } else {
      if (this.selectedSubCategory) {
        this.updateFileRequestQuery(this.selectedSubCategory);
      } else if (this.selectedParentCategory) {
        this.updateFileRequestQuery(this.selectedParentCategory);
      }
    }
  },
  methods: {
    getQuestionDisplayOrder(qs, q) {
      if (!qs || !q) {
        return "";
      }
      return `${qs.name[this.currentLanguage]}/${q.order}`;
    },
    handleHistoryIdParams() {
      this.historyId = this.$route.query?.historyId;
      const id = this.$route.query?.id;

      if (this.historyId && id) {
        const file = this.filePagination?.docs.find((f) => f._id == id);
        if (!file) return;
        this.viewVersions(file);
      }
    },

    editFile(file) {
      this.$store.commit(`fileManager/editedEntity`, { ...file });
      this.showUploadForm = true;

      this.$root.$emit("bv::toggle::collapse", "sidebar-file-upload");
    },
    breadcrumbClick(category) {
      if (category.parent) {
        this.selectSubCategory(undefined);
        this.selectSubCategory(category);
      } else {
        this.selectParentCategory(undefined);
        this.selectSubCategory(undefined);
        this.selectParentCategory(category);
      }
    },
    async downloadFile(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },
    async fetchFiles() {
      let request = { ...this.fileRequest };
      this.relatedEntityInfo = undefined;
      request = this.mutateFileRequest(request);

      request.query = {
        ...request.query,
        ...(this.scope ? { products: { value: this.scope, isObject: true } } : {}),
      };

      await this.$store.dispatch(`fileManager/paginate`, request);
    },
    async removeSubCategory(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationFileCategory/delete`, item._id);
        this.fetchSubCategories();
        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' " + this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async removeCategory(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationFileCategory/delete`, item._id);
        this.fetchParentCategories();
        this.fetchSubCategories();
        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' " + this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async deleteFile(file) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("fileManager/delete", file._id);
        this.fetchFiles();

        this.$toast.success(`${this.$t("common.delete-successful")} [${this.$options.filters.translate(file.name)}]`);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: error?.data?.message || `${this.$t("common.delete-fail")} [${this.$options.filters.translate(file.name)}]` });
      }
    },
    createNewFolder() {
      this.showCategoryForm = true;
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-file-category");
    },
    viewVersions(file) {
      this.$store.commit(`fileManager/selectedEntity`, { ...file });
      this.showHistory = true;
      this.$root.$emit("bv::toggle::collapse", "sidebar-file-history");
    },
    editAccessingMember(file) {
      this.$store.commit(`fileManager/selectedEntity`, { ...file });
      this.showAccessingMembers = true;
      this.$root.$emit("bv::toggle::collapse", "sidebar-accessing-member");
    },
    createNewFile() {
      this.showUploadForm = true;
      this.$root.$emit("bv::toggle::collapse", "sidebar-file-upload");
    },

    rightPanelClosed() {
      this.showAccessingMembers = false;
      this.showCategoryForm = false;
      this.showUploadForm = false;

      this.$store.commit(`organizationFileCategory/editedEntity`, null);
      this.$store.commit(`fileManager/editedEntity`, null);
      this.fetchParentCategories();
      this.fetchFiles();
    },
    async fileCategoryRightPanelClosed() {
      this.showAccessingMembers = false;
      this.showCategoryForm = false;
      this.showUploadForm = false;

      this.$store.commit(`organizationFileCategory/editedEntity`, null);
      this.$store.commit(`fileManager/editedEntity`, null);
      await this.fetchParentCategories();
      await this.fetchSubCategories();
      await this.fetchFiles();
    },
    async fetchParentCategories() {
      let request = JSON.parse(JSON.stringify(this.parentCategoryRequest));
      request.query = {
        ...request.query,
        ...(this.scope ? { products: { value: this.scope, isObject: true } } : {}),
      };
      request.options.sort = { ...request.options.sort, [`name.${this.currentLanguage}`]: "asc" };

      await this.$store.dispatch("organizationFileCategory/paginateParentCategories", request);
      if (!this.selectedParentCategory && !this.hasQuesyParams) {
        this.selectParentCategory(this.parentCategoryPagination?.docs?.[0]);
        this.$store.commit("organizationFileCategory/selectedParentCategory", this.parentCategoryPagination?.docs?.[0]);
      }
    },
    async fetchSubCategories() {
      if (!this.selectedSubCategory && !this.selectedParentCategory) {
        return;
      }
      let request = { ...this.subCategoryRequest };

      request.query = {
        ...request.query,
        ...(this.scope ? { products: { value: this.scope, isObject: true } } : {}),
      };

      await this.$store.dispatch("organizationFileCategory/paginateSubCategories", {
        id: this.selectedSubCategory?._id || this.selectedParentCategory?._id,
        pagination: request,
      });
    },
    addToBreadcrumb(category) {
      if (!this.breadcrumb.some((b) => b._id === category._id)) {
        this.breadcrumb.push(category);
      }
    },
    mutateFileRequest(request) {
      if (!this.hasQuesyParams) {
        return request;
      }

      this.selectParentCategory(undefined);
      this.selectSubCategory(undefined);

      const id = this.$route.query?.id;
      // const department = this.$route.query?.department;
      // const departmentName = this.$route.query?.departmentName;
      // const process = this.$route.query?.process;
      // const processName = this.$route.query?.processName;
      // const datasource = this.$route.query?.datasource;
      // const datasourceName = this.$route.query?.datasourceName;
      // const policy = this.$route.query?.policy;
      // const policyName = this.$route.query?.policyName;
      // const risk = this.$route.query?.risk;
      // const riskName = this.$route.query?.riskName;

      // this.relatedEntityInfo = {
      //   type: department
      //     ? this.$t("department.text")
      //     : process
      //     ? this.$t("process.text")
      //     : datasource
      //     ? this.$t("datasource.text")
      //     : policy
      //     ? this.$t("policy.text")
      //     : risk
      //     ? this.$t("help.platform.screen-panel.risk.text")
      //     : "",
      //   name: department ? departmentName : processName ? processName : datasourceName ? datasourceName : policyName ? policyName : riskName ? riskName : "",
      // };

      // request.query = {
      //   ...request.query,
      //   ...(id ? { _id: { value: id, isObject: true } } : {}),
      //   ...(department ? { "entity.department": { value: department, isObject: true } } : {}),
      //   ...(process ? { "entity.process": { value: process, isObject: true } } : {}),
      //   ...(datasource ? { "entity.datasource": { value: datasource, isObject: true } } : {}),
      //   ...(risk ? { "entity.risk": { value: risk, isObject: true } } : {}),
      // };
      return request;
    },
    resetBreadcrumb() {
      this.breadcrumb = [];
    },
    async selectParentCategory(category) {
      this.resetBreadcrumb();
      this.$store.commit("organizationFileCategory/selectedParentCategory", category);

      this.selectSubCategory(undefined);
      if (category) {
        if (this.hasQuesyParams) {
          this.$router.replace({ query: undefined });
        }
        this.updateFileRequestQuery(category);
        this.addToBreadcrumb(category);
      }
    },
    selectSubCategory(category) {
      this.$store.commit("organizationFileCategory/selectedSubCategory", category);
      if (category) {
        this.updateFileRequestQuery(this.selectedSubCategory);
        this.addToBreadcrumb(category);
      }
    },
    updateFileRequestQuery(category) {
      this.fileRequest.query = { ...this.fileRequest.query, category: { value: category?._id, isObject: true } };
    },
  },
};
</script>
<style scoped>
.category-item .trash-icon {
  visibility: hidden; /* Varsayılan olarak gizle */
}

.category-item:hover .trash-icon {
  visibility: visible; /* Hover durumunda göster */
}

.file-no-cell {
  max-width: 120px;
  word-break: break-word;
}
</style>
